class ProductBlog extends HTMLElement {
    constructor() {
        super();

        this.index = this.dataset.productIndex;
    }

    connectedCallback() {
        const productTemplate = document.querySelector(`template[data-product-index="${this.index}"]`);

        if (!productTemplate) {
            this.remove();
            return;
        }

        const cardClone = productTemplate.content.cloneNode(true);
        this.appendChild(cardClone);
        this.removeAttribute('hidden');
    }
}

customElements.get('product-blog') || customElements.define('product-blog', ProductBlog);